import {useBackgroundStyleConfigs} from 'hooks/useBackgroundStyleConfigs';

import {SubcomponentsLinkComponent} from 'lib/api/strapi';

import {Box, Typography} from 'components/basic-components';
import StrapiLink from 'components/basic-components/StrapiLink';

import styles from './seotags.module.scss';

export const SeoLink = (linkProps: SubcomponentsLinkComponent) => {
  const {linkText} = linkProps;
  const {textColor, seeThroughBackgroundColor} = useBackgroundStyleConfigs();
  return (
    <Box className={styles.seolinkbox} sx={{sm: {backgroundColor: seeThroughBackgroundColor}}}>
      <StrapiLink linkProps={linkProps} className={styles.anchortext}>
        <Typography sx={{color: textColor}} className={styles.linktext}>
          {linkText}
        </Typography>
      </StrapiLink>
    </Box>
  );
};
